import React from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../../FormElements/PageTitle';
import ProjectionsIndexCard from '../../Projections/ProjectionsIndexCard/ProjectionsIndexCard';

export default function ProjectionsIndexPage({
	get_projection_teams_endpoint,
	get_projection_players_endpoint
}) {
	if (!get_projection_teams_endpoint || !get_projection_players_endpoint) {
		return <div>Error: Missing projection endpoints.</div>;
	}

	return (
		<div className="container p-4 lg:py-14 md:px-20">
			<div className="mt-4">
				<div className="flex flex-wrap items-center justify-between gap-3">
					<PageTitle title="NFL Team Projections" />
					<Link
						to="/best-ball-zone"
						className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline"
					>
						← Best Ball Zone
					</Link>
				</div>
				<div className="grid grid-cols-1">
					<ProjectionsIndexCard
						get_projection_teams_endpoint={get_projection_teams_endpoint}
						get_projection_players_endpoint={get_projection_players_endpoint}
					/>
				</div>
			</div>
		</div>
	);
}
